import '@fortawesome/fontawesome-free/css/all.css'; // 引入Font Awesome
import { createApp, reactive } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import { globalConfig } from './config.js';
import HomePage from './views/HomePage.vue';

const routes = [
  { path: '/', component: HomePage },
  // 其他路由
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const app = createApp(App);

// 全局状态管理
const globalState = reactive({
  authenticated: !!localStorage.getItem('authenticated')
});

// 使用 provide 方法将全局状态提供给整个应用程序
app.provide('globalState', globalState);
app.provide('globalConfig', globalConfig);

app.use(router).mount('#app');
